import React, { useState } from "react";
import { Input, Typography } from "antd";
import { UserOutlined, MailOutlined, PhoneOutlined } from "@ant-design/icons";

const { Text } = Typography;

const PersonalInfoStep = ({
  firstName,
  lastName,
  email,
  phoneNumber,
  handleFirstNameChange,
  handleLastNameChange,
  handleEmailChange,
  handlePhoneChange,
}) => {
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");

  const isValidEmail = (value) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(value);
  };

  const isValidPhoneNumber = (value) => {
    const regex = /^\+?\d{7,15}$/; // supports +countrycode and 7-15 digits
    return regex.test(value);
  };

  const handleEmailInput = (e) => {
    const value = e.target.value;
    handleEmailChange(e);
    if (value && !isValidEmail(value)) {
      setEmailError("Invalid email format");
    } else {
      setEmailError("");
    }
  };

  const handlePhoneInput = (e) => {
    const value = e.target.value;
    handlePhoneChange(e);
    if (value && !isValidPhoneNumber(value)) {
      setPhoneError("Invalid phone number");
    } else {
      setPhoneError("");
    }
  };

  return (
    <div className="step-content">
      <h3>Personal Information</h3>

      <Input
        prefix={<UserOutlined />}
        placeholder="First Name"
        value={firstName}
        onChange={handleFirstNameChange}
        className="signup-input"
        style={{ marginBottom: 10 }}
      />

      <Input
        prefix={<UserOutlined />}
        placeholder="Last Name"
        value={lastName}
        onChange={handleLastNameChange}
        className="signup-input"
        style={{ marginBottom: 10 }}
      />

      <Input
        prefix={<MailOutlined />}
        placeholder="Email (optional)"
        value={email}
        onChange={handleEmailInput}
        className="signup-input"
        style={{ marginBottom: 5 }}
      />
      {emailError && <Text type="danger">{emailError}</Text>}

      <Input
        prefix={<PhoneOutlined />}
        placeholder="Phone Number"
        value={phoneNumber}
        onChange={handlePhoneInput}
        className="signup-input"
        style={{ marginBottom: 5 }}
      />
      {phoneError && <Text type="danger">{phoneError}</Text>}
    </div>
  );
};

export default PersonalInfoStep;
